import { secondaryPackagingRequest } from '@/request'
interface funResult {
	code?: number;
	data?: any;
	message?: any;
}
//登陆接口
export const Login = (data:any): Promise<funResult> => secondaryPackagingRequest({
    url: '/login',
    method: 'POST',
    headers: {
        'Content-Type': 'application/json'
    },
    data,
    isLoading: true,
    needToken: false,
})
//手机登录
export const phoneLogin = (data:any): Promise<funResult> => secondaryPackagingRequest({
    url: '/loginByPhone',
    method: 'POST',
    headers: {
        'Content-Type': 'application/json'
    },
    data,
    isLoading: true,
    needToken: false,
})
//登陆接口(无验证码)
export const autoLogin = (data:any): Promise<funResult> => secondaryPackagingRequest({
    url: '/auth/loginByNoCode',
    method: 'POST',
    headers: {
        'Content-Type': 'application/json'
    },
    data,
    isLoading: false,
    needToken: false,
})
//获取验证码
export const getCode = (): Promise<funResult> => secondaryPackagingRequest({
    url: '/getCode',
    isLoading: false,
    needToken: false
})
//获取用户菜单列表
export const getMenu = (): Promise<funResult> => secondaryPackagingRequest({
    url: '/menu',
    timeout: 10000,
    isLoading: false,
    needToken: true
})
//退出登陆
export const signOut = (): Promise<funResult> => secondaryPackagingRequest({
    url: '/logout',
    method: 'POST',
    headers: {
        'Content-Type': 'application/json'
    },
    isLoading: true,
    needToken: true,
})
//获取用户菜单列表
export const getVersion = (): Promise<funResult> => secondaryPackagingRequest({
    url: '/Api/getVersion',
    isLoading: false,
    needToken: false
})